import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";

import { SelfServeNode } from "../types";

import { useSelectedNode } from "./useSelectedNode";

interface SelectedNodesList {
  selectedNodes: SelfServeNode[];
}

export const useListOfSelectedNodes = (): SelectedNodesList => {
  const { level1Node, level2Node, level3Node, level4Node, level5Node } =
    useSelectedNode();

  const nodes = [level1Node, level2Node, level3Node, level4Node, level5Node];
  const selectedNodes = nodes.filter(isNotUndefined);

  return {
    selectedNodes,
  };
};
